import { type ComponentProps } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import InputItem from './InputItem'

type InputItemProps = ComponentProps<typeof InputItem>

interface Props extends InputItemProps {
  fieldName: string
}

export default function QuestionContent({ fieldName, ...otherProps }: Props) {
  return (
    <>
      <Text.Normal size="200" weight="medium" color="grey800" whiteSpace="breakSpaces">
        <Box style={{ overflowWrap: 'break-word' }}>{fieldName}</Box>
      </Text.Normal>
      <InputItem {...otherProps} />
    </>
  )
}
